/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import AttachmentItem from 'components/custom/ui/AttachmentItem';

const IdentificationDetail = ({ data }) => {
  let { Aadhar, PAN, ESIC, UAN, Passport, PF } =
    data?.identification_details?.reduce((acc, i) => {
      return {
        ...acc,
        [i.document_type]: i
      };
    }, {}) || {};

  return (
    <>
      <h2 className="mb-4">Identity Detail</h2>
      <div>
        <AttachmentItem
          label={'Aadhaar Number'}
          value={Aadhar?.document_identification_number}
          documents={
            Aadhar?.front_image && Aadhar?.back_image
              ? [
                  { name: 'Aadhaar Front', url: Aadhar?.front_image },
                  { name: 'Aadhaar Back', url: Aadhar?.back_image }
                ]
              : Aadhar?.front_image
                ? [{ name: 'Aadhaar Front', url: Aadhar?.front_image }]
                : Aadhar?.back_image
                  ? [{ name: 'Aadhaar Back', url: Aadhar?.back_image }]
                  : undefined
          }
        />

        <AttachmentItem
          label={'PAN Number'}
          value={PAN?.document_identification_number}
          documents={
            PAN?.front_image
              ? [{ name: 'Pan Card', url: PAN?.front_image }]
              : undefined
          }
        />

        <AttachmentItem
          label={'Passport Number'}
          value={Passport?.document_identification_number}
          documents={
            Passport?.front_image
              ? [{ name: 'Passport', url: Passport?.front_image }]
              : undefined
          }
        />

        <AttachmentItem
          label={'PF Number'}
          value={PF?.document_identification_number}
        />

        <AttachmentItem
          label={'UAN Number'}
          value={UAN?.document_identification_number}
        />

        <AttachmentItem
          label={'ESIC Number'}
          value={ESIC?.document_identification_number}
        />
      </div>
    </>
  );
};

export default IdentificationDetail;
